export const PC_CANVAS_CLASS = 'qx-pc-canvas'
export const PC_CANVAS_WIDTH = 375
export const PC_CANVAS_HEIGHT = 812
export const DESIGN_VIEWPORT_WIDTH = 750

export const isPcCanvas = (): boolean =>
  typeof document !== 'undefined' && document.documentElement.classList.contains(PC_CANVAS_CLASS)

export const getLogicalViewportWidth = (): number => {
  if (isPcCanvas()) return PC_CANVAS_WIDTH
  return typeof window === 'undefined' ? 0 : window.innerWidth
}

export const getLogicalViewportHeight = (): number => {
  if (isPcCanvas()) return PC_CANVAS_HEIGHT
  if (typeof window === 'undefined') return 0
  return window.visualViewport?.height || window.innerHeight || 0
}

export const getLogicalLayoutViewportHeight = (): number => {
  if (isPcCanvas()) return PC_CANVAS_HEIGHT
  return typeof window === 'undefined' ? 0 : window.innerHeight
}

/** Return a viewport-height value without changing the mobile/App representation. */
export const viewportHeightCssValue = (percentage: number): string => {
  if (isPcCanvas()) return `${(percentage / 100) * PC_CANVAS_HEIGHT}px`
  return `${percentage}vh`
}

export const designPxToLogicalPx = (designPx: number): number =>
  (designPx / DESIGN_VIEWPORT_WIDTH) * getLogicalViewportWidth()

/** Preserve the existing mobile vw value while fixing runtime design pixels on PC. */
export const designPxToLogicalCssValue = (designPx: number): string => {
  if (isPcCanvas()) return `${designPxToLogicalPx(designPx)}px`
  return `${((designPx / DESIGN_VIEWPORT_WIDTH) * 100).toFixed(6)}vw`
}
